import * as React from "react";
import {Route, Switch} from "react-router-dom";
import DisbursalInfo from "Loans/LoanList/DisbursalInfo";
import LoanList from "Loans/LoanList";
import RlocInfo from "Loans/Rloc/RlocInfo";
import Withdraw from "Loans/Rloc/Withdraw";

export enum PaymentDetailsRoutes {
  LOANS = "loans",
  PAYMENT_DETAILS = "details",
  RLOC_DETAILS = "rloc-details",
  WITHDRAW = "withdraw",
}

export const getRoutes = (path: string) => {
    return (
        <Switch>
            <Route exact path={`${path}`} component={LoanList}/>
            <Route exact path={`${path}/${PaymentDetailsRoutes.PAYMENT_DETAILS}`} component={DisbursalInfo}/>
            <Route exact path={`${path}/${PaymentDetailsRoutes.RLOC_DETAILS}`} component={RlocInfo}/>
            <Route exact path={`${path}/${PaymentDetailsRoutes.RLOC_DETAILS}/${PaymentDetailsRoutes.WITHDRAW}`} component={Withdraw}/>
        </Switch>
    );
};
